import { applyTheme } from './applyTheme';

export const ADMIN_ORIGIN = 'https://admin.menulynx.com';

export function isPreviewMode(search: string = window.location.search): boolean {
  return new URLSearchParams(search).get('preview') === '1';
}

interface PreviewMessage {
  themeId?: string;
  brandColor?: string;
  accentColor?: string;
}

export function initThemePreview(): () => void {
  const handler = (event: MessageEvent) => {
    if (event.origin !== ADMIN_ORIGIN) return;
    const msg = (event.data || {}) as PreviewMessage;
    if (!msg.themeId) return;
    applyTheme(msg.themeId, msg.brandColor, msg.accentColor);
  };
  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
}
